import * as React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MobileNav } from './MobileNav';
import { DesktopSidebar } from './DesktopSidebar';
import { Header } from './Header';

interface AppShellProps {
  children?: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const location = useLocation();
  const { t } = useTranslation('common');
  const isCookingMode = location.pathname.startsWith('/cook/session');
  const mainId = 'main-content';
  const routeKey = `${location.pathname}${location.search}`;

  if (isCookingMode) {
    return (
      <div style={{ minHeight: '100vh', background: 'var(--bg-page, #F9FAFB)' }}>
        <a href={`#${mainId}`} className="skip-link">
          {t('a11y.skipToContent')}
        </a>
        <main id={mainId} style={{ minHeight: '100vh' }} className="route-transition-shell">
          <div key={routeKey} className="route-transition-content">
            {children ?? <Outlet />}
          </div>
        </main>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-page, #F9FAFB)' }}>
      <a href={`#${mainId}`} className="skip-link">
        {t('a11y.skipToContent')}
      </a>

      <DesktopSidebar />

      {/* Main content wrapper - margin applied via media query in style */}
      <div
        style={{
          marginInlineStart: 0,
          transition: 'margin-inline-start var(--motion-duration-standard) var(--motion-ease-standard)',
        }}
        className="main-content-wrapper"
      >
        <Header />

        <main
          id={mainId}
          className="route-transition-shell"
          style={{
            minHeight: 'calc(100vh - 64px)',
            padding: '24px 16px 96px 16px',
          }}
        >
          <div key={routeKey} className="route-transition-content">
            {children ?? <Outlet />}
          </div>
        </main>
      </div>

      <MobileNav />

      {/* Responsive styles for sidebar margin */}
      <style>{`
        @media (min-width: 1024px) {
          .main-content-wrapper {
            margin-inline-start: 260px !important;
          }
        }
      `}</style>
    </div>
  );
}
